"use client";

import dynamic from "next/dynamic";
import Image from "next/image";
const MuxPlayer = dynamic(() => import("@mux/mux-player-react"), { ssr: false });

interface VideoProps {
  playbackId: string;
  client?: string;
  alt?: string;
  classes?: string;
  time?: number;
}

export default function Video({ playbackId, client, alt, classes, time=0 }: VideoProps) {
  if (!playbackId) return null;
  const videoTitle = client ? `Case Study Reel for ${client}` : alt || "Video Player";

  return (
    <div className={`relative bg-black ${classes}`}>
      <Image
        src={`https://image.mux.com/${playbackId}/thumbnail.jpg?time=${time}`}
        alt={videoTitle}
        className="object-cover w-full h-full"
        fill
        priority
        sizes="100vw"
      />
      <MuxPlayer
        playbackId={playbackId}
        metadata={{ video_title: videoTitle }}
        autoPlay
        muted
        loop
        nohotkeys
        className={`object-cover w-full h-full`}
      />
    </div>
  );
}
